import { Button, Spin } from "antd";
import ICustomButtonProps from "components/CustomButton/ICustomButtonProps";

import "./CustomButton.css";
import { EnumDictionary } from "types/EnumDictionary";
import { gaCategory } from "types/HsbGaTypes";
import ReactGA from "react-ga4";
import { CustomButtonType, CustomButtoState } from "components/CustomButton/CustomButtonType";
import { useState } from "react";

export const buttonTypeCssClassEnum: EnumDictionary<CustomButtonType, string> = {
	[CustomButtonType.positive]: "button-positive",
	[CustomButtonType.negative]: "button-negative",
	[CustomButtonType.buttonNoPreference]: "button-no-pref",
};

const CustomButton: React.FC<ICustomButtonProps> = ({
	text,
	style,
	OnClick,
	OnClickAsync,
	htmlType,
	value,
	className = "",
	buttonType,
	enabled = true,
	loading = false,
	...props
}) => {
	const [internalState, setInternalState] = useState<CustomButtoState>(
		loading ? CustomButtoState.loading : enabled ? CustomButtoState.enabled : CustomButtoState.disabled
	);

	const onButtonClick = () => {
		setInternalState(CustomButtoState.loading);
		ReactGA.event({ category: gaCategory.pageLoad, action: buttonType });
		if (OnClick) {
			OnClick();
			setInternalState(enabled ? CustomButtoState.enabled : CustomButtoState.disabled);
		} else if (OnClickAsync) {
			OnClickAsync().then(() => {
				setInternalState(enabled ? CustomButtoState.enabled : CustomButtoState.disabled);
			});
		} else {
			setInternalState(enabled ? CustomButtoState.enabled : CustomButtoState.disabled);
		}
	};

	return (
		<Button
			{...props}
			htmlType={htmlType || "button"}
			style={style}
			className={
				buttonTypeCssClassEnum[buttonType] +
				" " +
				className +
				(props.icon !== undefined ? "custom-icon-button" : "") +
				(text === "" ? " no-text" : "")
				+(internalState === CustomButtoState.loading?" loading":"")
			}
			size="large"
			value={value || ""}
			onClick={onButtonClick}
			disabled={!enabled || internalState === CustomButtoState.loading}
		>
			<Spin spinning={internalState === CustomButtoState.loading} />
			{text && text.trim() !== "" && <span aria-label={text}>&nbsp;&nbsp;{text} &nbsp;&nbsp;</span>}
		</Button>
	);
};

export default CustomButton;
